export function mapsLoaded() {
    const windowRef = window || {};
    const g = windowRef.google;
    return g && g.maps && g.maps.places;
}

export function loadAutoCompleteAPI(config) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDJ4-leNZZAqX21Og3lI8CPWIcmtTIaymo&callback=googleMapsAutoCompleteAPILoad&libraries=places,geocoding&region=${config.region}&language=${config.lang}&channel=eg-ulx`;
    document.querySelector('head').appendChild(script);
}

export function loadWrapper(loaderImplementation) {
    return (apiKey) => {
        if (typeof window !== 'undefined') {
            if (mapsLoaded()) {
                // It's possible maps were loaded by some other consumer already.
                // Making the below request with a different mapChannel
                //    would result in a double load of google maps API
                return Promise.resolve(window.google.maps);
            }

            const deferred = (resolve) => {
                loaderImplementation(apiKey);

                window.googleMapsAutoCompleteAPILoad = () => {
                    resolve(window.google.maps);
                };

                // TODO: setTimeout to reject?
            };
            return new Promise(deferred);
        }
        return Promise.resolve(null);
    };
}

export default {
    load: loadWrapper(loadAutoCompleteAPI)
};
